export default function(groups_data, coursework_listing) {
  var self = this;

  self.$el = $('#admin_group_listing');
  self.statuses = ko.observableArray(['pending', 'active']);
  self.total_groups = ko.observable();
  self.groups = ko.observableArray();
  self.group_paginator = ko.observable();
  self.coursework = ko.observableArray();
  self.selectedCourseworkId = ko.observable();

  self.selectedSort = ko.observable();
  self.selectedStatus = ko.observable();
  self.searchQuery = ko.observable();

  self.sortOptions = ko.observableArray([
    { id: 1, name: 'Created At Ascending', param: 'created_at', direction: 'asc'  },
    { id: 2, name: 'Created At Descending', param: 'created_at', direction: 'desc'  },
    { id: 3, name: 'Member Count Ascending', param: 'members_count', direction: 'asc' },
    { id: 4, name: 'Member Count Descending', param: 'members_count', direction: 'desc' }
  ]);

  self.bindData = function(groups_data, coursework_listing) {
    var mapped_groups = ko.mapping.fromJS(groups_data.groups);
    self.groups(mapped_groups());

    self.total_groups(groups_data.total_groups);
    self.group_paginator(groups_data.group_paginator);

    if (coursework_listing) {
      self.coursework(ko.mapping.fromJS(coursework_listing)());
      self.courses = ko.computed(function() {
        var list = ko.utils.arrayMap(self.coursework(), function(cw){
          return cw.course_name();
        });

        return ko.utils.arrayGetDistinctValues(list);
      });
    }
  };

  self.initUI = function() {
    self.bindPaginationEvents();

    $('#groupSearch').on('keypress', function(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13') {
        $('#groupSearch').blur();
        self.filterChanged();
      }
    });
  };

  self.bindPaginationEvents = function() {
    var $page_number = $('.page_number'),
      total_pages = parseInt($('.total_pages').text()),
      current_page = parseInt($('.current_page').text());

    $page_number.keyup(function(e){
      if(e.keyCode == 13){
        changePage($(this).val());
      }
    });
    $page_number.blur(function(e){
      changePage($(this).val());
    });

    $('.pagination a').off('click');
    $('.pagination a').on('click', function() {
      var url = $(this).attr('href');
      if (url != '#') {
        self.groupListing(url);
      }
      return false;
    });

    var changePage = function(pageNumber){
      if (parseInt(pageNumber)) {
        var destination_page = (pageNumber <= total_pages) ? pageNumber : total_pages;
        var url = Kadenze.Routes.admin_coursework_groups_path() + '?page=' + destination_page;
        self.groupListing(url);
      } else {
        $page_number.val(current_page);
      }
    };

  };

  /*------------------------------------------GROUP STATE MANAGEMENT FUNCTIONS-------------------------------------*/
  self.consolidateGroups = function(item, event) {
    var request = new Kadenze.AjaxRequest({
      type: 'POST',
      url:  Kadenze.Routes.consolidate_admin_coursework_groups_path({coursework_id: self.selectedCourseworkId()})
    });

    request.done(function(data) {
      new Kadenze.Notice.success({ message: data.message });
    });

    request.fail(function(data) {
      new Kadenze.Notice.error({ message: data.responseJSON.message });
    });
  };
  /*------------------------------------------GROUP SEARCH/FILTERING FUNCTIONS-------------------------------------*/

  self.groupListing = function (url, params) {
    var request,
      requestUrl = url ? url : Kadenze.Routes.admin_coursework_groups_path();

    request = new Kadenze.AjaxRequest({
      type: 'GET',
      dataAsJSON: false,
      url: requestUrl,
      data: params,
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(function(data) {
      self.bindData(data);
      self.bindPaginationEvents();
      Kadenze.Layout.update(); // Helps reset the footer / sidebar when there's dramatic changes in the course list lengths
    });

    request.fail(function(data) {
      console.warn('Failed to get courses: ', data);
      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
    });
  };

  self.filterChanged = function () {
    var sortOption = self.getSort(self.selectedSort()),
      sortParam = sortOption ? sortOption.param : '',
      sortDirection = sortOption ? sortOption.direction: '',
      status = self.selectedStatus(),
      params = {
        sort: sortParam,
        direction: sortDirection,
        q: self.searchQuery(),
        status: status,
        coursework_id: self.selectedCourseworkId()
      };

    self.groupListing(null, $.param(params));
  };

  self.selectedStatus.subscribe(self.filterChanged);
  self.selectedSort.subscribe(self.filterChanged);
  self.selectedCourseworkId.subscribe(self.filterChanged);

  self.getSort = function(id) {
    return _.find(self.sortOptions(), function(option) { return option.id === id; });
  };

  const __construct = function(that) {
    console.log('constructor called for AdminCourseworkGroupListingViewModel');
    that.bindData(groups_data, coursework_listing);
  }(this);
}
